import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/CSE503mid21.pdf'
import cse from '../assets/CSE503end21.pdf'
import csm from '../assets/cse503mid21.pdf'
export default function Os() {
  return (
    <div>
       <Subject title="Operating System(CSE503)" sub="Op. system" syllabus="#"mid="Q. Paper"
    book1="Operating System Concepts Essentials, 9th Edition by AviSilberschatz, Peter Galvin, Greg Gagne, 
    Wiley Asia Student Edition"
    book2="Operating Systems: Internals and Design Principles, 5th Edition, William Stallings, Prentice Hall of India"
    book1Link="https://drive.uqu.edu.sa/_/mskhayat/files/MySubjects/2017SS%20Operating%20Systems/Abraham%20Silberschatz-Operating%20System%20Concepts%20(9th,2012_12).pdf
    "
     book2Link="https://repository.dinus.ac.id/docs/ajar/Operating_System.pdf
     " int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}